import { createAction, props } from '@ngrx/store';

import { FecalScoring } from '../../model/fecal-scoring.model';
import { UpsertFecalScoringResponse } from '../../services/fecal-scoring-service.model';

export const loadData = createAction('[FecalScoring] Load Data');
export const clearFecalScoringState = createAction('[FecalScoring] Clear State');
export const clearSelectedFecalScoring = createAction('[FecalScoring] Clear Selected FecalScoring');

export const setSelectedFecalScoringRequest = createAction(
  '[FecalScoring] Set Selected FecalScoring Request',
  props<{ id: number }>(),
);
export const setSelectedFecalScoringSuccess = createAction(
  '[FecalScoring] Set Selected FecalScoring Success',
  props<{ fecalScoring: FecalScoring }>(),
);
export const setSelectedFecalScoringError = createAction(
  '[FecalScoring] Set Selected FecalScoring Error',
  props<{ error: Error }>(),
);

export const getFecalScoringsRequest = createAction('[FecalScoring] Get FecalScorings Request');
export const getFecalScoringsSuccess = createAction(
  '[FecalScoring] Get FecalScorings Success',
  props<{ fecalScorings: FecalScoring[] }>(),
);

export const getFecalScoringsError = createAction(
  '[FecalScoring] Get FecalScorings Error',
  props<{ error: Error }>(),
);

export const upsertFecalScoringRequest = createAction(
  '[FecalScoring] Upsert FecalScoring Request',
  props<{ request: FecalScoring }>(),
);
export const upsertFecalScoringSuccess = createAction(
  '[FecalScoring] Upsert FecalScoring Success',
  props<{ request: FecalScoring; response: UpsertFecalScoringResponse }>(),
);
export const upsertFecalScoringError = createAction(
  '[FecalScoring] Upsert FecalScoring Error',
  props<{ error: Error }>(),
);

export const deleteFecalScoringRequest = createAction(
  '[FecalScoring] Delete FecalScoring Request',
  props<{ fecalScoring: FecalScoring }>(),
);
export const deleteFecalScoringWithConfirmation = createAction(
  '[FecalScoring] Confirm Delete FecalScoring',
  props<{ fecalScoring: FecalScoring }>(),
);
export const deleteFecalScoringSuccess = createAction(
  '[FecalScoring] Delete FecalScoring Success',
  props<{ fecalScoringId: number }>(),
);

export const navigateCreateFecalScoring = createAction(
  '[FecalScoring] Navigate to create fecal scoring',
  props<{ locationId: number }>(),
);
